$(function(){


    $( "#btn_footer_subscription" ).on( "click", function() {
        console.log( "Handler for `click` called." );
        
    } );

});
